type Props = {
  className?: string;
  style?: React.CSSProperties;
  isExpanded?: boolean;
};

export const FinecoDownloadIcon: React.FC<Props> = ({
  className,
  style,
  isExpanded,
}) => {
  return (
    <div className={className} style={style}>
      <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_730_350561)">
          <mask
            id="mask0_730_350561"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="25"
            height="25"
          >
            <path d="M0.5 0.433594H24.5V24.4336H0.5V0.433594Z" fill="white" />
          </mask>
          <g mask="url(#mask0_730_350561)">
            <path
              d="M1.62477 24.4336C1.32621 24.4336 1.03987 24.315 0.828748 24.1039C0.617629 23.8927 0.499023 23.6064 0.499023 23.3078C0.499023 23.0093 0.617629 22.7229 0.828748 22.5118C1.03987 22.3007 1.32621 22.1821 1.62477 22.1821H23.3748C23.6662 22.1927 23.9422 22.316 24.1446 22.526C24.3471 22.7359 24.4602 23.0162 24.4602 23.3078C24.4602 23.5995 24.3471 23.8798 24.1446 24.0897C23.9422 24.2997 23.6662 24.423 23.3748 24.4336H1.62477ZM12.0723 19.2736C11.9506 19.2193 11.839 19.1447 11.7423 19.0531C11.7333 19.0426 11.7198 19.0396 11.7093 19.0291L5.18427 12.5026C5.07987 12.3983 4.99704 12.2744 4.9405 12.1381C4.88396 12.0018 4.85482 11.8557 4.85475 11.7081C4.85468 11.5605 4.88368 11.4144 4.94009 11.278C4.9965 11.1417 5.07922 11.0177 5.18352 10.9133C5.28783 10.8089 5.41167 10.7261 5.54799 10.6696C5.6843 10.613 5.83042 10.5839 5.97799 10.5838C6.12557 10.5838 6.27171 10.6128 6.40808 10.6692C6.54445 10.7256 6.66837 10.8083 6.77277 10.9126L11.3778 15.5176V1.55859C11.3782 1.26087 11.4964 0.9754 11.7067 0.764593C11.9169 0.553786 12.202 0.434783 12.4998 0.433594C12.6476 0.433594 12.794 0.462742 12.9306 0.519373C13.0672 0.576003 13.1913 0.659004 13.2958 0.763629C13.4003 0.868254 13.4831 0.99245 13.5396 1.12911C13.596 1.26578 13.625 1.41223 13.6248 1.56009V15.5191L18.2298 10.9141C18.4419 10.7091 18.726 10.5955 19.021 10.598C19.3159 10.6004 19.5981 10.7186 19.8068 10.927C20.0155 11.1355 20.134 11.4176 20.1367 11.7126C20.1394 12.0076 20.0261 12.2918 19.8213 12.5041L13.2963 19.0306C13.2858 19.0411 13.2708 19.0441 13.2603 19.0546C13.1641 19.1469 13.0524 19.2216 12.9303 19.2751C12.7946 19.3308 12.6494 19.3598 12.5028 19.3606C12.355 19.3599 12.2087 19.3303 12.0723 19.2736Z"
              fill="#0133cd"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_730_350561">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.5 0.433594)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
